import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';

import SongList from './song-list';

const injectSongStore = inject('songsStore');

export default injectSongStore(
	observer(
		({ songsStore, artistID }) => (
			<SongList
				songList={
					songsStore.getSongsByArtistID(artistID)
				}
			/>
		)
	)
);
